// export let pluginConfig = {
//   lang: 'en',
//   position: 'bottom-right',
//   offset: [20, 20],
//   size: 58
// };

import type { IconItem, WidgetConfig } from "../types/widget";
import { Accessibility, Eye, Settings, Palette } from "lucide-react";

export const ICON_LIBRARY: IconItem[] = [
  { id: "accessibility", icon: Accessibility, name: "Accessibility" },
  { id: "eye", icon: Eye, name: "Eye" },
  { id: "settings", icon: Settings, name: "Settings" },
  { id: "palette", icon: Palette, name: "Palette" },
];

export const POSITION_OPTIONS = [
  { value: "top-left", label: "Top Left" },
  { value: "top-right", label: "Top Right" },
  { value: "bottom-left", label: "Bottom Left" },
  { value: "bottom-right", label: "Bottom Right" },
];

export const TEXT_ALIGNMENT_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" },
];

export const defaultConfig: WidgetConfig = {
  status: {
    mobile: true,
    desktop: true,
  },
  iconId: "default",
  iconSize: 48,
  label: "Accessibility widget",
  heading: "Accessibility menu",
  position: {
    mobile: "bottom-right",
    desktop: "bottom-right",
  },
  language: {
    default: "en",
    selected: [],
  },
  margins: {
    desktop: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,    
    },
    mobile: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    },
  },
  primaryColor: "#1863DC",
  modules: {
    color: {
      darkContrast: { enabled: false },
      lightContrast: { enabled: false },
      highContrast: { enabled: false },
      highSaturation: { enabled: false },
      lightSaturation: { enabled: false },
      monochrome: { enabled: false },
    },
    content: {
      highlightText: { enabled: false },
      highlightLinks: { enabled: false },
      dyslexicFont: { enabled: true },
      letterSpacing: { enabled: false },
      lineHeight: { enabled: true },
      fontWeight: { enabled: false },
    },
    statement: {
      enabled: false,
      url: "",
    },
  },
};

declare global {
  interface Window {
    _cyA11yConfig?: WidgetConfig;
  }
}

export const pluginConfig: WidgetConfig = Object.assign(defaultConfig, window._cyA11yConfig);